import {useLayoutEffect} from "react"
import {PortalsPanelItem} from "../../../../types/securityTypes"

export const useSyncHeaderHeight = (currentPortal?: PortalsPanelItem): void => {
    useLayoutEffect(() => {
        const isTallerHomeHeader =
            currentPortal === PortalsPanelItem.Home &&
            !globalThis.location.pathname.includes("profile")

        document.documentElement.style.setProperty(
            "--header-height",
            isTallerHomeHeader ? "5.625rem" : "3.75rem"
        )
    }, [currentPortal, globalThis.location.pathname])
}
